export enum EventType {
    EVENT_TYPE_UNSPECIFIED = 0,
    EVENT_TYPE_LINK_OPENED = 1,
    EVENT_TYPE_PAGE_LOADED = 2,
    EVENT_TYPE_USER_AGREEMENT_ACCEPTED = 3,
    EVENT_TYPE_USER_AGREEMENT_REJECTED = 4,
    EVENT_TYPE_CALL_TO_DRIVER = 5,
    EVENT_TYPE_CHAT_WITH_CEXP = 6,
}
